<template>
    <div>    
        <div class="top"></div>    
        <div class="content">
            <h1 class="title">
                <img src="../../src/assets/images/logo.png" alt="">
                <p class="title-text">RebaLoan</p>
            </h1>
            <h2 class="feature-tit">
                Sign In
            </h2>
            <div class="form">
                <div class="form-container">
                    <label class='label' for="">Mobile No.</label>
                    <div class="input-container">
                        <div class="prefix">+91</div>
                        <div class="input-content-container">
                            <input type="tel" v-model="obj.phone" placeholder="Enter your  phone number here!" @input="phoneInput">
                        </div>
                    </div>                    
                </div>
                <div class="form-container">
                    <label class='label' for="">OTP</label>
                    <div class="input-container">                            
                        <div class="input-content-container">
                            <input type="tel" v-model="obj.code" placeholder="Enter the verification code" @input="codeInput">
                        </div>
                        <button class="get_code" @click="sendCodeFn">{{ code_text }}</button>
                    </div>
                    <div class="error" v-show='obj.is_error'>
                        <i class="icon icon-exclaim"></i> 
                        <p class="error-text" v-text="obj.error_text"></p>
                    </div>                
                </div>                  
                <div class="btn-container">
                    <button class="btn-submit" :class="{'active':btn_active}" @click="submit">
                        LOGIN
                    </button>        
                </div>
                <!-- <div class="check-container">
                    <label class='check-container' @click="toggleCheck" for="">
                        <i class="icon" :class="{'icon-check': obj.checked, 'icon-uncheck': !obj.checked}"></i>
                        <p class="label-caption">
                            By Login you agree to our <router-link to="/protocol/privacy" ><em>Privacy Policy</em></router-link> and <router-link to="/protocol/term"><em>Terms & Conditions</em></router-link>
                        </p>
                    </label>
                </div>       -->
            </div> 
        </div>
                        
    </div>    
</template>
<style lang="less" scoped>
@import "assets/less/icon.less";
.title{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 50px;
    img{
        width: 90px;
        height: 90px;
        margin-right:20px;        
    }
    font-size:56px;
}
.top{
    padding-bottom: 50px;
    .top-bg{
        background:url("~assets/images/login/top-bg.png") no-repeat;
        background-size: 100% 100%;
        width: 750px;
        height: 342px;        
        position: relative;
        .logo{
            background:url("~assets/images/login/logo.png") no-repeat;
            background-size:100%;
            width: 136px;
            height: 136px;
            position: absolute;
            bottom: 50px;
            right:100px;
        }
        .title{
            padding-top: 50px;
            color:#8960e8;
            font-size: 36px;
            margin-left: -80px;
        }
        .caption{
            font-size: 28px;
            color:#8960e8;
            margin-top: 30px;
            line-height: 1.5;
            margin-left: -80px;
        }
    }
}
.content{
    width: 670px;
    padding:50px 30px;
    height: 750px;
    margin: 0 auto;
    background-size:100% 100%;
    .feature-tit{
        color:#66687D;
        font-size: 56px;
        margin-bottom: 50px;
    }
    .form{
        width: 670px;
        .form-container{
            .label{
                display: block;
                color:#66687D;
                font-size: 30px; 
                margin: 50px 0 15px 0;
            }
        }
        .input-container{
            padding:30px 0 30px 0;
            display:flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom:2px solid #666;   
            height: 50px;         
            .prefix{
                display:block;
                color:#333;
                font-size: 32px;
                height:50px;      
                line-height: 50px;      
                border-right:1px solid #999;
                padding:0 20px 0 0;
                margin-right: 20px;;
            }
            .get_code{
                display: block;
                width: 168px;
                height: 72px;
                background: #fff;
                border-radius: 36px;
                border:2px solid #8960e8;
                text-align: center;
                line-height: 72px;
                padding: 0;
                margin: 0;
                color:#8960e8;
                font-size: 28px;
            }
            .input-content-container{
                flex:1;
                // margin-left: 20px;
                input{
                    display:block;
                    width: 100%;
                    height: 100%;
                    border:none;
                    font-size: 32px;
                    background:transparent;
                    color:#333;
                    &::placeholder{
                        color:#8960e8;
                    }
                }
            }
        }
    }
    .error{
        display:flex;
        justify-content: flex-start;
        margin-top: 10px;
        .icon{
            margin-right: 20px;
            flex: 0 0 auto;
        }
        .error-text{
            flex:1 0 auto;
            font-size: 24px;
            color:#C5340B;
        }
    }            

}
    .check-container{
                    display: flex;
                    margin-top: 30px;
                    padding:0 30px;
                    color:#333;
                    .icon{
                        flex:1 0 auto;
                        margin-right: 20px;
                    }
                    .label-caption{
                        font-size: 24px;
                        color:#777777;
                        line-height: 1.5;
                        color:#333;
                        em{
                            text-decoration: underline;
                            color:#333;
                        }
                    }
                }
    .btn-container{
        width: 670px;
        margin: 50px auto;               
            .btn-submit{
                display: block;                
                width: 670px;
                height: 100px;
                background: #8960e8;
                border-radius: 20px;
                line-height: 100px;
                text-align: center;
                color:#fff;
                font-size: 32px;
                border: none; 
                text-align:center;
                &.active{
                    background: linear-gradient(90deg,  0%, #8960e8 100%);
                }
            }
        }        
</style>
<script>
import { reactive, computed, ref,  getCurrentInstance } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { sendCode } from "@api/index"
// import { getAnalytics, logEvent } from 'firebase/analytics'
// import First from '@/components/business/login/first.vue'
// import Second from '@/components/business/login/second.vue'
export default { 
    // components:{
    //     First,
    //     Second
    // },   
    setup() {
        // const analytics = getAnalytics()
        const router = useRouter()
        const route = router.currentRoute
        const store = useStore()
        const secondRef = ref()
        const proxy  = getCurrentInstance().proxy
        const obj = reactive({
            checked: true,
            is_error: false,
            phone: '',
            error_text: '',            
            state: 0   ,
            code: '',
            clicked: false,
        })       
        const code_text = ref("Get") 
        const code_clicked = ref(false) 
        const btn_text = computed(()=>{
            if(obj.state == 0) {
                return 'Send OTP'
            } else {
                return 'Next'
            }
        })
        const btn_active = computed(()=>{
            return (obj.phone.length == 10 & obj.checked  & obj.code.length == 4)
        })        
        let to = 0
        const sendCodeFn = async () => {
            if (!obj.checked) {
                obj.is_error = true
                obj.error_text = 'Please agree with Loan Guarantee Argreement.'
            } else {
                if(code_clicked.value)return
                code_clicked.value = true
                let data = await sendCode({
                    phone: "91"+obj.phone
                })
                if(data.code == 0) {
                    obj.secs = 60
                    to = setInterval(()=>{                    
                        code_text.value = `${--obj.secs}s`
                        if(obj.secs<=0){
                            clearInterval(to)
                            code_text.value = 'resend'
                            code_clicked.value = false
                        }
                    },1000)
                    // logEvent(analytics, 'register_send_sms')
                } else {
                    code_clicked.value = false
                    obj.is_error = true
                    obj.error_text = data.msg
                }
            }
        }
        const phoneInput = () => {
            if(/D+/.test(obj.phone) | obj.phone.length > 10) {                
                obj.phone = obj.phone.substring(0, obj.phone.length - 1)                
            }            
        } 
        const codeInput = () => {
            if(/\D+/.test(obj.code) | obj.code.length > 4) {                
                obj.code = obj.code.substring(0, obj.code.length - 1)                
            }            
        } 
        
        const submit = async () => {
            if(obj.clicked) return 
            if(obj.code == '') return 
            obj.clicked = true            
            store.dispatch('login',{
                phone:obj.phone,
                code:obj.code
            }).then((resp)=>{
                // logEvent(analytics, 'register_logined')
                obj.clicked = false
                if(resp.isRegister == 1) {
                    window.fbq('track', 'CompleteRegistration');
                }
                console.log(route)
                if(route.value.query.redirect) {
                    router.replace({
                        path:route.value.query.redirect
                    })        
                } else {
                    router.replace({
                        path:'/'
                    })
                }           
                
            }).catch((msg)=>{   
                obj.clicked = false                 
                proxy.$toast.show(msg)
            })
            
        }
        
        const toggleCheck = () => {
            obj.checked = !obj.checked            
        }       
        const setPhone = (phone) => {
            obj.phone = phone
        }
        const setCode = (code) => {
            obj.code = code
        }
        const changeState = (state) => {
            obj.state = state
        }
        const back = () => {
           changeState(0)
        }
        return {
            obj, submit,sendCodeFn, toggleCheck, btn_active,setPhone,secondRef,btn_text,setCode, back,phoneInput,codeInput,code_text
        }
    }    
}
</script>